export default __webpack_public_path__ + "static/media/phirki.93e32ecb.jpeg";